import React from 'react';
import './PetAnimations.css';

export default function LlamaSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#F0E6D4';
  const lightColor = color ? lighten(color) : '#FAF4E8';
  const darkColor = color ? darken(color) : '#C8BDA8';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <ellipse cx="90" cy="68" rx="5" ry="4" fill={darkColor} />
      {/* Body - fluffy */}
      <ellipse cx="65" cy="72" rx="28" ry="22" fill={bodyColor} />
      {/* Fluffy texture */}
      <circle cx="50" cy="62" r="6" fill={lightColor} opacity="0.5" />
      <circle cx="65" cy="58" r="5" fill={lightColor} opacity="0.5" />
      <circle cx="78" cy="64" r="5" fill={lightColor} opacity="0.4" />
      <circle cx="55" cy="78" r="4" fill={lightColor} opacity="0.3" />
      {/* Decorative blanket */}
      <rect x="50" y="58" width="30" height="16" rx="2" fill="#E84040" />
      <rect x="50" y="62" width="30" height="3" fill="#FFD700" />
      <rect x="50" y="68" width="30" height="3" fill="#4488CC" />
      {/* Blanket fringe */}
      <line x1="52" y1="74" x2="52" y2="78" stroke="#E84040" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="56" y1="74" x2="56" y2="78" stroke="#FFD700" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="60" y1="74" x2="60" y2="78" stroke="#E84040" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="64" y1="74" x2="64" y2="78" stroke="#FFD700" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="68" y1="74" x2="68" y2="78" stroke="#E84040" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="72" y1="74" x2="72" y2="78" stroke="#FFD700" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="76" y1="74" x2="76" y2="78" stroke="#E84040" strokeWidth="1.5" strokeLinecap="round" />
      {/* Legs */}
      <rect x="44" y="86" width="8" height="18" rx="3" fill={bodyColor} />
      <rect x="54" y="86" width="8" height="18" rx="3" fill={darkColor} />
      <rect x="70" y="86" width="8" height="18" rx="3" fill={bodyColor} />
      <rect x="80" y="86" width="8" height="18" rx="3" fill={darkColor} />
      {/* Hooves */}
      <rect x="43" y="102" width="10" height="4" rx="2" fill="#6B5B4F" />
      <rect x="53" y="102" width="10" height="4" rx="2" fill="#6B5B4F" />
      <rect x="69" y="102" width="10" height="4" rx="2" fill="#6B5B4F" />
      <rect x="79" y="102" width="10" height="4" rx="2" fill="#6B5B4F" />
      {/* Neck - long */}
      <rect x="38" y="30" width="18" height="38" rx="8" fill={bodyColor} />
      {/* Neck fluff */}
      <circle cx="42" cy="45" r="4" fill={lightColor} opacity="0.4" />
      <circle cx="50" cy="40" r="3" fill={lightColor} opacity="0.3" />
      {/* Head */}
      <ellipse cx="47" cy="24" rx="16" ry="14" fill={bodyColor} />
      {/* Muzzle */}
      <ellipse cx="47" cy="30" rx="8" ry="6" fill={lightColor} />
      {/* Ears - banana shaped */}
      <path d="M34 14C30 6 28 4 32 10L36 16Z" fill={bodyColor} />
      <path d="M60 14C64 6 66 4 62 10L58 16Z" fill={bodyColor} />
      <path d="M35 14C32 8 30 6 33 11L36 16Z" fill="#E8A0A0" />
      <path d="M59 14C62 8 64 6 61 11L58 16Z" fill="#E8A0A0" />
      {/* Eyes - half closed, judgy */}
      <ellipse cx="40" cy="22" rx="3.5" ry="2" fill="white" />
      <ellipse cx="54" cy="22" rx="3.5" ry="2" fill="white" />
      <ellipse cx="41" cy="22" rx="2" ry="1.5" fill="#2C2419" />
      <ellipse cx="55" cy="22" rx="2" ry="1.5" fill="#2C2419" />
      <circle cx="42" cy="21.5" r="0.6" fill="white" />
      <circle cx="56" cy="21.5" r="0.6" fill="white" />
      {/* Judgy eyelids (half-closed) */}
      <path d="M36 21C38 20 42 20 44 21" stroke={bodyColor} strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M50 21C52 20 56 20 58 21" stroke={bodyColor} strokeWidth="2" strokeLinecap="round" fill="none" />
      {/* Nose */}
      <ellipse cx="47" cy="28" rx="2" ry="1.5" fill="#8B7B6F" />
      {/* Mouth - slight smirk */}
      <path d="M43 32C45 33 49 33 51 31" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
